import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const localeActionSheetI18n = {
	[ELocaleCode.RU_RU]: {
		save: 'Сохранить',
	},
	[ELocaleCode.EN_US]: {
		save: 'Save',
	},
};
